class TextToSpeach {
    _btn: HTMLButtonElement;
    _txt: HTMLElement;
    _player: HTMLElement;
    _audio: HTMLAudioElement;
    _source: HTMLSourceElement;

    constructor( btn: HTMLButtonElement ) {
        this._btn = btn;
        this._txt = btn.querySelector( '.txt' ) as HTMLElement;
        this._btn.classList.add( 'texttospeach' );
        this._init();
    }

    _init(): void {
        this._audio = document.createElement( 'audio' );
        this._audio.controls = true;
        this._audio.autoplay = true;
        this._audio.loop = false;
        this._audio.preload = 'none';
        this._audio.setAttribute( 'controlslist', 'nodownload nofullscreen' );

        this._audio.addEventListener( 'pause', this._onAudioPause.bind( this ) );
        this._audio.addEventListener( 'play', this._onAudioPlay.bind( this ) );
        this._audio.addEventListener( 'ended', this._onAudioEnded.bind( this ) );
        this._audio.addEventListener( 'volumechange', this._onAudioVolumeChange.bind( this ) );

        this._source = document.createElement( 'source' );
        this._source.type = 'audio/mp3';

        this._player = document.createElement( 'aside' );
        this._player.className = 'texttospeach__player';

        this._audio.appendChild( this._source );
        this._player.appendChild( this._audio );

        this._btn.addEventListener( 'click', this._onClick.bind( this ) );
    }

    async _onClick( event: Event ): Promise<void> {
        if ( !event.target || !( event.target instanceof HTMLButtonElement ) ) {
            return;
        }

        if ( !this._player.parentElement ) {
            if ( !this._source.src ) {
                this._source.src = this._btn.dataset.source as string;
                this._audio.load();
            }
            document.body.appendChild( this._player );
        }

        if ( this.isPlaying ) {
            this.stop();
        } else {
            await this.play();
        }
    }

    async play(): Promise<void> {
        this._btn.classList.add( 'texttospeach--playing' );
        this._btn.classList.remove( 'texttospeach--paused' );
        this._txt.innerHTML = this._btn.dataset.speachTextStop || '';
        this._player.classList.remove( 'texttospeach__player--hidden' );
        await this._audio.play();
    }

    stop(): void {
        this._btn.classList.remove( 'texttospeach--playing' );
        this._btn.classList.remove( 'texttospeach--paused' );
        this._txt.innerHTML = this._btn.dataset.speachTextPlay || '';
        this._player.classList.add( 'texttospeach__player--hidden' );
        this._audio.pause();
        this._audio.currentTime = 0;
    }

    _onAudioPlay( event: Event ): void {
        this._btn.classList.add( 'texttospeach--playing' );
        this._btn.classList.remove( 'texttospeach--paused' );
        this._txt.innerHTML = this._btn.dataset.speachTextStop || '';
    }

    _onAudioPause( event: Event ): void {
        this._btn.classList.remove( 'texttospeach--playing' );

        if ( this._audio.currentTime !== 0 ) {
            this._btn.classList.add( 'texttospeach--paused' );
            this._txt.innerHTML = this._btn.dataset.speachTextResume || '';
        }
    }

    _onAudioEnded( event: Event ): void {
        this._player.classList.add( 'texttospeach__player--hidden' );
        this._btn.classList.remove( 'texttospeach--playing' );
        this._txt.innerHTML = this._btn.dataset.speachTextPlay || '';
    }

    _onAudioVolumeChange( event: Event ): void {
        if ( this._audio.muted || this._audio.volume === 0 ) {
            this._audio.pause();
            this._btn.classList.remove( 'texttospeach--playing' );
            this._btn.classList.add( 'texttospeach--paused' );
            this._txt.innerHTML = this._btn.dataset.speachTextResume || '';
        }
    }

    get isPlaying(): boolean {
        return this._btn.classList.contains( 'texttospeach--playing' );
    }
}

export default function initTextToSpeachButtons() {
    document.querySelectorAll<HTMLButtonElement>( '[data-action="text-to-speach"]' ).forEach( ( btn: HTMLButtonElement ) => {
        new TextToSpeach( btn );
    } );
}
